// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2NNgL","footer__link":"Footer_footer__link__1NxUG"};